// Configurable web analytics for the public site.
//
// Exposes initAnalytics(measurementId) and trackPageView(path). The mechanism
// stays disabled until a measurement id is configured: with a null/empty (or
// whitespace-only) id, initAnalytics is a no-op that loads no tracking script
// and records nothing, and trackPageView does nothing (Requirement 13.6).

const GTAG_SCRIPT_ID = 'ga-gtag'

let measurementId = null
let enabled = false

function isValidMeasurementId (id) {
  return typeof id === 'string' && id.trim().length > 0
}

// Initialise analytics with the given measurement id. Returns true when
// tracking was activated, false when it stays disabled (no id configured).
export function initAnalytics (id) {
  // Reset on every call so repeated/initial calls are deterministic.
  measurementId = null
  enabled = false

  if (!isValidMeasurementId(id)) {
    // No id configured: no-op. Load no script and track nothing.
    return false
  }

  measurementId = id.trim()
  enabled = true
  loadGtagScript(measurementId)
  return true
}

// Record a page view for the given path. No-op while analytics is disabled.
// Returns true when a page view was recorded, false otherwise.
export function trackPageView (path) {
  if (!enabled) {
    return false
  }
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false
  }
  window.gtag('event', 'page_view', { page_path: path })
  return true
}

// Whether analytics tracking is currently active. Useful for verifying the
// gating behaviour without inspecting global side effects.
export function isAnalyticsEnabled () {
  return enabled
}

function loadGtagScript (id) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return
  }
  // Avoid injecting the tracking script more than once.
  if (document.getElementById(GTAG_SCRIPT_ID)) {
    return
  }

  const script = document.createElement('script')
  script.id = GTAG_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag () {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', id)
}
